import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-gray-900 border border-gray-200 shadow-xl",
          success:
            "bg-green-50 text-green-900 border-green-300",
          error:
            "bg-red-50 text-red-900 border-red-300",
          description: "text-gray-600",
          actionButton:
            "bg-teal-600 text-white",
          cancelButton:
            "bg-gray-100 text-gray-600",
        },
        style: {
          fontSize: '14px',
          padding: '12px 16px',
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
